import { useTranslation } from "react-i18next";
import TabsNavigationBar from "../../components/bar/TabsNavigationBar/TabsNavigationBar";

function InvoicingNavigationBar(props) {
    const { t } = useTranslation();
    return (
        <TabsNavigationBar
            multipleLocationKey={props.multipleLocationKey}
            pages={[
                {
                    label: t("headers.invoicing_investment_bills"),
                    link: "/financial-panel/invoicing/investment_bills/",
                },
                {
                    label: t("headers.invoicing_individual_bills"),
                    link: "/financial-panel/invoicing/invoicing_individual_bills/",
                },
                {
                    label: t("headers.invoicing_invoices"),
                    link: "/financial-panel/invoicing/invoices/",
                },
                {
                    label: t("headers.invoicing_agreements"),
                    link: "/financial-panel/invoicing/agreements/",
                },
                {
                    label: t("headers.invoicing_symfonia_codes"),
                    link: "/financial-panel/invoicing/symfonia_codes/",
                },
            ]}
        />
    );
}

export default InvoicingNavigationBar;
